import React from 'react';
import styled from 'styled-components';
import { Palette } from 'config';

export const LengthCounter = ({ maxSize, str }) => {
  return <Box MAX_SIZE={maxSize}>{str?.length}</Box>;
};

export const Box = styled.div`
  color: ${Palette.PrimaryGray._600};
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  ::after {
    content: ${({ MAX_SIZE }) => `"/${MAX_SIZE}"`};
    color: ${Palette.PrimaryGray._400};
    font-weight: 400;
  }
`;
